var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"btn btn-ghost base-button flex-shrink-0 no-print border"},'button',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"base-button__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }